// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_obj from "../../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as BinarySearchUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/BinarySearchUtils.bs.js";

function getInterpolatedCoordinate(timestamp, input) {
  var comparator = function (x, y) {
    if (Caml_obj.caml_equal(x, y)) {
      return 0;
    } else if (Timestamp$Catalyst.isBefore(x, y)) {
      return 1;
    } else {
      return -1;
    }
  };
  var value = BinarySearchUtils$Catalyst.binarySearch(timestamp, $$Array.map((function (x) {
              return x.ts;
            }), input), 0, input.length, comparator);
  if (value.TAG !== /* Ok */0) {
    if (value._0) {
      return {
              TAG: /* ErrorAboveHighest */2,
              _0: Caml_array.get(input, input.length - 1 | 0).point
            };
    } else {
      return {
              TAG: /* ErrorBelowLowest */1,
              _0: Caml_array.get(input, 0).point
            };
    }
  }
  var match = value._0;
  var endIndex = match[1];
  var startIndex = match[0];
  if (startIndex === endIndex) {
    return {
            TAG: /* Interpolated */0,
            _0: Caml_array.get(input, startIndex).point
          };
  }
  var startTime = Caml_array.get(input, startIndex).ts;
  var endTime = Caml_array.get(input, endIndex).ts;
  var splitRatio = Math.abs((Timestamp$Catalyst.toFloat(timestamp) - Timestamp$Catalyst.toFloat(startTime)) / (Timestamp$Catalyst.toFloat(endTime) - Timestamp$Catalyst.toFloat(startTime)));
  return {
          TAG: /* Interpolated */0,
          _0: {
            lat: Caml_array.get(input, startIndex).point.lat * splitRatio + Caml_array.get(input, endIndex).point.lat * (1.0 - splitRatio),
            lng: Caml_array.get(input, startIndex).point.lng * splitRatio + Caml_array.get(input, endIndex).point.lng * (1.0 - splitRatio)
          }
        };
}

export {
  getInterpolatedCoordinate ,
  
}
/* Timestamp-Catalyst Not a pure module */
